<template>
  <notifications
    :group="PROMO_LINK_TOAST_GROUP"
    class="be-promo-toast-host"
    position="top center"
    animation-name="be-promo-toast"
    :width="TOAST_WIDTH"
    :duration="TOAST_DURATION_MS"
    :max="TOAST_MAX_VISIBLE">
    <template slot="body" slot-scope="props">
      <div
        class="be-promo-toast"
        :class="`be-promo-toast--${props.item.type || 'warn'}`"
        role="status"
        aria-live="polite">
        <div class="be-promo-toast__icon" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
            <path d="M9 9h.01" />
            <path d="m15 9-6 6" />
            <path d="M15 15h.01" />
          </svg>
        </div>
        <div class="be-promo-toast__content">
          <p class="be-promo-toast__title">{{ props.item.title || $t('hotel.filter.promotion-link.unavailable-title') }}</p>
          <p v-if="props.item.text" class="be-promo-toast__text">{{ props.item.text }}</p>
        </div>
        <button
          type="button"
          class="be-promo-toast__close"
          aria-label="Close"
          @click="props.close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
        <span class="be-promo-toast__progress" :style="progressStyle" aria-hidden="true"></span>
      </div>
    </template>
  </notifications>
</template>

<script>
  const PROMO_LINK_TOAST_GROUP = 'promo-link';
  const TOAST_WIDTH = 420;
  const TOAST_DURATION_MS = 6000;
  const TOAST_MAX_VISIBLE = 2;

  export default {
    name: 'BePromoLinkToast',
    data() {
      return { PROMO_LINK_TOAST_GROUP, TOAST_WIDTH, TOAST_DURATION_MS, TOAST_MAX_VISIBLE };
    },
    computed: {
      progressStyle() {
        return { animationDuration: `${TOAST_DURATION_MS}ms` };
      }
    }
  };
</script>

<!-- unscoped: vue-notification renders the group root and transition wrappers outside this scope -->
<style>
/* sits below the BE navbar (78px desktop / 64px mobile) so Login/Register stay clickable */
.be-promo-toast-host.vue-notification-group {
  top: 92px !important;
  z-index: 1060;
}
.be-promo-toast-host .vue-notification-wrapper {
  overflow: visible;
  padding: 0 0 10px;
}
.be-promo-toast {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 14px 16px 16px;
  overflow: hidden;
  border: 1px solid #e3e6eb;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(17, 24, 39, 0.14), 0 2px 6px rgba(17, 24, 39, 0.06);
  color: #1a1a2e;
  font-family: inherit;
  text-align: left;
}
.be-promo-toast__icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--be-promo-toast-tint);
  color: var(--be-promo-toast-accent);
}
.be-promo-toast--warn {
  --be-promo-toast-accent: #b45309;
  --be-promo-toast-tint: #fef3c7;
}
.be-promo-toast--success {
  --be-promo-toast-accent: var(--merchant-primary-color, #15803d);
  --be-promo-toast-tint: #ecfdf3;
}
.be-promo-toast--error {
  --be-promo-toast-accent: #b91c1c;
  --be-promo-toast-tint: #fee2e2;
}
.be-promo-toast__content {
  flex: 1;
  min-width: 0;
  padding-top: 1px;
}
.be-promo-toast__title {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.be-promo-toast__text {
  margin: 3px 0 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: #5f6b76;
}
.be-promo-toast__close {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: -4px -4px 0 0;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #8a94a0;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;
}
.be-promo-toast__close:hover {
  background: #f2f4f7;
  color: #1a1a2e;
}
.be-promo-toast__progress {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background: var(--be-promo-toast-accent);
  opacity: 0.55;
  transform-origin: left center;
  animation: bePromoToastCountdown linear forwards;
}
@keyframes bePromoToastCountdown {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}
.be-promo-toast-enter-active,
.be-promo-toast-leave-active,
.be-promo-toast-move {
  transition: opacity 220ms cubic-bezier(0.22, 0.61, 0.36, 1), transform 220ms cubic-bezier(0.22, 0.61, 0.36, 1);
}
.be-promo-toast-enter,
.be-promo-toast-leave-to {
  opacity: 0;
  transform: translateY(-12px) scale(0.98);
}
@media screen and (max-width: 767.98px) {
  .be-promo-toast-host.vue-notification-group {
    top: 76px !important;
    left: 16px !important;
    width: auto !important;
    right: 16px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .be-promo-toast-enter-active,
  .be-promo-toast-leave-active,
  .be-promo-toast-move {
    transition: opacity 150ms linear;
  }
  .be-promo-toast-enter,
  .be-promo-toast-leave-to {
    transform: none;
  }
  .be-promo-toast__progress {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/BePromoLinkToast.vue